document.addEventListener("DOMContentLoaded", function () {
    function hideUpcartProperties() {
        const propertiesToHide = [
            'Disc Design Url Type',
            'Disc Assets'
        ];

        document.querySelectorAll('.upcart-item-property strong').forEach(element => {
            const text = element.textContent.trim();

            if (text.includes('Disc Design Url:')) {
                const property = element.closest('.upcart-item-property');
                const urlSpan = property.querySelector('span');
                const imageUrl = urlSpan ? urlSpan.textContent.trim() : '';

                if (imageUrl && imageUrl.startsWith('http')) {
                    property.innerHTML = '<strong>Design: </strong>';

                    const link = document.createElement('a');
                    link.href = imageUrl;
                    link.target = '_blank';
                    link.title = 'View full design';
                    link.textContent = 'View Design';
                    link.style.marginLeft = '5px';
                    link.style.color = '#0073e6';
                    link.style.textDecoration = 'underline';
                    link.style.cursor = 'pointer';

                    property.appendChild(link);
                }
            } else if (propertiesToHide.some(prop => text.includes(prop))) {
                element.closest('.upcart-item-property').style.display = 'none';
            }
        });
    }

    function hideInUbantu() {
        const cartForm = document.querySelector('form#cart');
        if (!cartForm) return;

        cartForm.querySelectorAll('.cart__info .line-item').forEach(item => {
            const label = item.querySelector('b');
            if (label) {
                const text = label.textContent.trim();

                if (text === 'Disc Design Url Type:' || text === 'Disc Assets:') {
                    item.style.display = 'none';
                } else if (text === 'Disc Design Url:') {
                    const urlSpan = item.querySelector('span');
                    const url = urlSpan ? urlSpan.textContent.trim() : '';

                    if (url && url.startsWith('http')) {
                        item.innerHTML = '<b>Design: </b>';

                        const link = document.createElement('a');
                        link.href = url;
                        link.target = '_blank';
                        link.title = 'View full design';
                        link.textContent = 'View Design';
                        link.style.marginLeft = '5px';
                        link.style.color = '#0073e6';
                        link.style.textDecoration = 'underline';
                        link.style.cursor = 'pointer';

                        item.appendChild(link);
                    }
                }
            }
        });
    }

    function hideProperties() {
        hideUpcartProperties();
        hideInUbantu();
    }

    // Run once on load
    hideProperties();

    // 🔥 Use MutationObserver to watch for cart DOM changes
    const observer = new MutationObserver(() => {
        hideProperties();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
